import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Configurator } from '../components/Configurator';
import { useLanguage } from '../context/LanguageContext';
import { getSessionId } from '../lib/utils';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback products data
const DEFAULT_PRODUCTS = {
  folgo: {
    id: 'folgo',
    name: 'FOLGO',
    description: 'Vélo cargo PLIANT compact et polyvalent. Idéal pour la ville et les trajets quotidiens.',
    description_en: 'Compact and versatile FOLDING cargo bike. Ideal for city and daily commutes.',
    base_price: 2990,
    images: ['https://customer-assets.emergentagent.com/job_belleville-bikes/artifacts/x78evn8g_FOLGO%20OK%20DER%20%2B.jpg'],
    type: 'bike',
    specs: {}
  },
  cargo: {
    id: 'cargo',
    name: 'CARGO CLASSIQUE',
    description: 'Vélo cargo classique, pour transporter tout ce que vous voulez.',
    description_en: 'Classic cargo bike, to transport everything you want.',
    base_price: 2800,
    images: ['https://customer-assets.emergentagent.com/job_belleville-bikes/artifacts/yiav7i8c_cargo%20classique%20vert%20FB.jpg'],
    type: 'bike',
    specs: {}
  }
};

export default function ProductPage() {
  const location = useLocation();
  const { language } = useLanguage();
  // Extract product ID from path like /product/folgo -> folgo
  const productId = location.pathname.split('/').pop();
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${API}/products/${productId}`);
        setProduct(response.data);
      } catch (error) {
        // Error handled silently
        setProduct(DEFAULT_PRODUCTS[productId] || null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchProduct();
    
    // Log visitor
    axios.post(`${API}/visitor/log`, {
      page: `product-${productId}`,
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
      referrer: document.referrer
    }).catch(() => {});
  }, [productId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="font-mono text-muted-foreground">Produit non trouvé</p>
      </div>
    );
  }

  // Use localized description
  const localizedProduct = {
    ...product,
    description: language === 'en' && product.description_en ? product.description_en : product.description
  };

  return (
    <div className="min-h-screen bg-white" data-testid={`product-page-${productId}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <Configurator product={localizedProduct} isKit={false} />
      </div>
    </div>
  );
}
